import { environment } from "../../../../../environments/environment";
import { opsMissionTypeEnum, payloadCodeTypeEnum } from "../../dataStruct";
import { checkFlightDuringNighttime, getFirstNvfrWpt } from "../../functions";
import { navLegStruct } from "../navLogReport";
import { PayLoadStruct } from "./fccProvider";
import { aircraftStruct, fppProvider } from "./fppProvider";

export class rmksStruct {
  value: number;
  rmk: string;
}

export class opsAocRulesProvider {
  public ecetDiffMin: number = 30;
  public paxDefaultWeight: number = 104;
  public getExtraWeightPos: number = 9;
  getFinalReserveTime(etd: Date, navlog: navLegStruct[]): rmksStruct {
    const ff = checkFlightDuringNighttime(etd, navlog, this.ecetDiffMin);
    const nl = new rmksStruct();
    if (ff == false) {
      nl.rmk = "20 min  day";
      nl.value = 20 * 60;
    } else {
      nl.rmk = "30 min NVFR";
      nl.value = 30 * 60;
    }

    return nl;
  }
  async getAdditionalFuel(etd: Date, navlog: navLegStruct[], acft: aircraftStruct, classCom: any): Promise<rmksStruct> {
    // get fueltanks
    const fpp = new fppProvider();
    const fuelTanks = await fpp.getLoadingObjectsAircraftModel(acft.registration, payloadCodeTypeEnum.fuel, classCom);

    let supplyMass: number = 0;
    let mainMass: number = 0;
    for (let i = 0; i < fuelTanks.length; i++) {
      if (fuelTanks[i].name.startsWith("Supply")) {
        supplyMass += fuelTanks[i].weightMaxUsable;
      }

      if (fuelTanks[i].name.startsWith("Main")) {
        mainMass += fuelTanks[i].weightMaxUsable;
      }
    }

    const nl = new rmksStruct();

    const ff = await checkFlightDuringNighttime(etd, navlog, this.ecetDiffMin);

    if (ff) {
      const wpt = await getFirstNvfrWpt(etd, navlog, this.ecetDiffMin);
      if (wpt != "") {
        nl.rmk =
          acft.registration + ": Supplytanks (" + supplyMass + " KG) + 50 kg Maintank. NVFR from/to " + wpt + ".";
      } else {
        nl.rmk = acft.registration + "NVFR, Supplytanks (" + supplyMass + " KG) + 50 kg Maintank.";
      }
      nl.value = supplyMass + 50;
    } else {
      nl.rmk = acft.registration + " Supplytanks (" + supplyMass + " KG) full";
      nl.value = supplyMass + 0;
    }

    if (environment.fuelPolicyReference) {
      nl.rmk += " (*" + environment.fuelPolicyReference + "*)";
    }

    const reserve = (await this.getFinalReserveTime(etd, navlog)).value;
    nl.value -= reserve * acft.tacticalFuelBurn;
    nl.rmk += ", deducted are " + Math.round(reserve * acft.tacticalFuelBurn) + " kg  Final Reserve Fuel.";

    if (!acft.registration.startsWith("OEX")) {
      nl.value = 0;
      nl.rmk = "";
    }

    return nl;
  }

  // this function was done to have a feature to unload booked passengers
  // from the aircraft, especially on EMS_Incubator
  public changePaxLoadingDependingOnOpsMissionType(
    inLoading: PayLoadStruct[],
    opsMissionType: opsMissionTypeEnum
  ): PayLoadStruct[] {
    if (opsMissionType == opsMissionTypeEnum.ems_incubator) {
      // remove the doctor
      for (let i = 0; i < inLoading.length; i++) {
        if (inLoading[i].name.startsWith("Dr.")) {
          inLoading.splice(i, 1);
        }
      }

      return inLoading;
    } else {
      return inLoading;
    }
  }

  public removeSeatsOfOpsMissionType(inLoading: PayLoadStruct[], opsMissionType: opsMissionTypeEnum) {
    if (opsMissionType == opsMissionTypeEnum.ems_incubator) {
      // remove the doctor
      for (let i = 0; i < inLoading.length; i++) {
        if (inLoading[i].name.includes("Trage vordere Position")) {
          inLoading.splice(i, 1);
        }
      }

      return inLoading;
    } else {
      return inLoading;
    }
  }
}
